import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

import { gerarUrl } from "../../utilities/utils/Pageable";

export default class UserService extends Token {
  searching(queryParams) {
    queryParams = gerarUrl(queryParams);
    return axios({
      method: "get",
      url: this.api_url + "user?" + queryParams,
      withCredentials: true,
    }).then((res) => res.data);
  }

  findById(id) {
    return axios({
      method: "get",
      url: this.api_url + "user/" + id,
      withCredentials: true,
    }).then((res) => res.data);
  }

  create(user) {
    return axios({
      method: "post",
      url: this.api_url + "user",
      withCredentials: true,
      data: user,
    });
  }

  createUserAndPassword(user) {
    return axios({
      method: "post",
      url: this.api_url + "user/create",
      data: user,
    });
  }

  update(user) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + user.id,
      withCredentials: true,
      data: user,
    });
  }

  resetPassword(user) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + user.id + "/resetar-password",
      withCredentials: true,
    });
  }
  recoverPassword(email, param) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + email + "/recuperar-password",
      data: param,
    });
  }

  activateRegistration(user) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + user.email + "/ativar-cadastro",
      withCredentials: true,
    });
  }

  updatePassword(id, newPassword) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + id + "/update-password",
      withCredentials: true,
      data: newPassword,
    });
  }

  updateStatus(user) {
    return axios({
      method: "put",
      url: this.api_url + "user/" + user.id + "/ativo",
      withCredentials: true,
      data: user.status,
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  delete(id) {
    return axios({
      method: "delete",
      url: this.api_url + "user/" + id,
      withCredentials: true,
    });
  }
}
